import salesEvents from './salesEvents';

export function dispatchEvent(eventName, detail = {}) {
  salesEvents.add('event', eventName, detail);
  const event = new CustomEvent(eventName, {
    bubbles: false,
    cancelable: false,
    composed: false,
    detail
  });
  document.dispatchEvent(event);
}


export const sendUserBuiltEvent = user => {
  dispatchEvent("userBuilt", { user });
}

export function subscribe(eventName, listener) {
  document.addEventListener(eventName, listener);
}

export function unsubscribe(eventName, listener) {
  document.removeEventListener(eventName, listener);
}